import { render } from "./ProductDonutChart.vue?vue&type=template&id=1b81369c"
import script from "./ProductDonutChart.vue?vue&type=script&lang=js"
export * from "./ProductDonutChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__